import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import {makeStyles, Typography} from "@material-ui/core";
import DoubleButton from "components/popup/components/DoubleButton";
import VS from "constants/ValidationShema";
import TextInput from "components/TextInput";
import SiwzService from "services/SiwzService";
import {isDemandPreparing} from "libs/getDemandStatus";
import Loading from "components/Loading";
import Button from "components/Button";
import DemandService from "services/DemandService";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    loading: {
        width: '98%'
    },
    buttonRow: {
        textAlign: "end"
    }
}));

function AddBzpNoticePopup(
    {
        demandId,
        onClose,
        formSubmit,
        siwzTypes,
    }) {

    const classes = useStyle();

    const [working, setWorking] = useState(false);
    const [errorText, setErrorText] = useState();
    const [downloadSuccess, setDownloadSuccess] = useState(false);

    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    const processResponse = async (resp) => {
        if (resp.success) {
            await DemandService.getValidate(demandId, false)
            await SiwzService.getList(demandId);
            setDownloadSuccess(true);
        } else {
            setErrorText(resp.errors.shift());
        }

    }

    const onSubmit = ({bzpNoticeId}) => {
        setWorking(true);
        setErrorText();
        const bzpSiwzType = Object.keys(siwzTypes).find(x => "notice_changed" === x || "noticeAttachments" === x);
        SiwzService.addBzpNotice(demandId, bzpNoticeId.trim(), bzpSiwzType).then(processResponse).catch(() => {
        }).finally(() => {
            setWorking(false);
        });
    }


    if(downloadSuccess) {
        return (
            <Dialog
                title={isDemandPreparing() ? Tr("add_bzp_notice") : Tr("add_bzp_notice_update")}
                maxWidth={'sm'}
                open={true}
                onClose={onClose}
            >
                <Typography>
                    {Tr('bzp_notice_downloaded')}
                </Typography>
                <div className={classes.buttonRow}>
                    <Button
                        onClick={onClose}
                    >
                        {Tr('close')}
                    </Button>
                </div>
            </Dialog>)
    }


    return (
        <Dialog
            title={isDemandPreparing() ? Tr("add_bzp_notice") : Tr("add_bzp_notice_update")}
            open={true}
        >
            <Form
                initialValues={{
                    bzpNoticeId: "",
                }}
                validationSchema={Yup.object().shape({
                    bzpNoticeId: VS.string().test('bzp-nitice', Tr("bzp_notice_number_invalid"), (bzpNoticeId) => {
                        if(!!bzpNoticeId) {
                            bzpNoticeId = bzpNoticeId.trim();
                            if(bzpNoticeId.includes("-N-")) {
                                const split = bzpNoticeId.split("-N-");
                                if(split.length === 2) {
                                    return /^[0-9]{6,9}$/.test(split[0]) && /^[0-9]{4}$/.test(split[1]);
                                }
                            } else if(bzpNoticeId.includes("/BZP")) {
                                return /^[0-9]{4}\/BZP\s?[0-9]{8}\/[0-9]{2}$/.test(bzpNoticeId);
                            }
                        }
                        return false;
                    }),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>
                        {working && <Loading className={classes.loading}/>}

                        <TextInput
                            id='bzpNoticeId'
                            formikProps={formikProps}
                            label={Tr('bzp_notice_number')}
                            disabled={working}
                        />

                        {!!errorText && <Typography
                            variant='body1'
                            color='error'
                        >
                            {Tr(errorText)}
                        </Typography>}

                        <div className={classes.actions}>
                            <DoubleButton
                                justify='flex-end'
                                labelFirst={Tr('cancel')}
                                labelSecond={Tr('confirm')}
                                onClickFirst={onClose}
                                onClickSecond={handleSubmit}
                                disabledFirst={working}
                                disabledSecond={working}
                            />
                        </div>
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

AddBzpNoticePopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired
};

export default connect((state) => ({
    siwzTypes: state.resources[SiwzService.SIWZ_TYPE_LIST_RESOURCE_ID],
    formSubmit: state.form
}), {})(AddBzpNoticePopup);